import { closeApp, openForm } from "../actions/appStatus";
import {
  updateAppointmentStepStartDateTime,
  getStaffServicesAndMore,
  getProfileForCurrentUser,
  loadCachedProviderDetails,
  updateCurrentlyLoggedInStaff,
  loadCachedProfileForCurrentUser,
  moveAppointmentTriggered
} from "../actions/appointmentStep";
import {
  getExistingBooking,
  getUpdatedToken,
  loadCachedExistingBooking
} from "../actions/booking";
import { updateBookingOnlyCustomerProfileData } from "../actions/customerProfile";
import {
  convertTimeFromApi,
  convertDateTimeFromApi,
  isInternetExplorer
} from "../utils/helpers";
import { convertAppointmentFromApiModel } from "../utils/dataConversion";

import { timeList } from "../state/hardDataset";
import moment from "moment";
import get from "lodash/get";
export function handleReceiveMessage(event) {
  if (
    event.origin.indexOf("beyond-booking") < 0 &&
    event.origin.indexOf("genbook.com") < 0 &&
    event.origin.indexOf("localhost") < 0 &&
    event.origin.length != ""
  )
    return;

  if (!window.dispatch) {
    console.error("app not ready");
  }

  let translatedData = {};
  let startDateTime = "";
  let formatedTime = "";
  let internalTimeItem = "";
  let locationId = void 0;

  try {
    translatedData = JSON.parse(event.data);
  } catch (ex) {
    console.warn("Unreadable message received", ex, event);
  }
  window.loadedCacheProviderData = false;
  window.loadedCacheUserData = false;
  window.parentContainer = event.source;
  switch (translatedData.action) {
    case "close":
      window.loadedCacheProviderData = false;
      window.loadedCacheUserData = false;
      window.dispatch(closeApp());
      break;
    case "open":
      let mainElement = document.getElementsByClassName(
        "bookingframe-bg-overlay"
      )[0];
      mainElement.removeAttribute("style");
      window.appIsClosing = false;
      window.customerCounter = 0; //DES-817
      window.dispatch(openForm(translatedData.mode));
      break;
    case "updateCurrentlyLoggedInStaff":
      window.dispatch(updateCurrentlyLoggedInStaff(translatedData.actionData));
      break;
    case "loadCachedProviderDetails":
      window.loadedCacheProviderData = true;

      window.SERVICE_PROVIDER_ID = translatedData.actionData.id;
      window.dispatch(loadCachedProviderDetails(translatedData.actionData));
      break;
    case "loadCachedUserDetails":
      window.loadedCacheUserData = true;
      window.dispatch(
        loadCachedProfileForCurrentUser(translatedData.actionData)
      );
      break;
    case "sendTokenJWT":
      if (!translatedData.actionData.tokenJWT)
        console.error("tokenJWT is missing");

    //window.sessionStorage.setItem('token_authorization', translatedData.actionData.tokenJWT);
    case "loadExistingBooking":
      if (!translatedData.actionData.existingBookingId == undefined)
        console.error("existingBookingId is missing");

      if (translatedData.actionData.existingBookingId) {
        let payload = { data: {} };
        payload.bookingId = translatedData.actionData.existingBookingId;

        payload.data.advancedAppointmentStepData = window.store.getState().advancedAppointmentStepReducer.advancedAppointmentStepData;
        payload.data.appointmentStepData = window.store.getState().appointmentStepReducer.appointmentStepData;
        window.dispatch(getExistingBooking(payload));
      }
      break;
    case "loadCachedExistingBooking":
      if (!translatedData.actionData == undefined)
        console.error("existingBookingId is missing");

      let payload = { data: {} };
      payload.bookingId = translatedData.actionData.id;
      payload.data.advancedAppointmentStepData = window.store.getState().advancedAppointmentStepReducer.advancedAppointmentStepData;
      payload.data.appointmentStepData = window.store.getState().appointmentStepReducer.appointmentStepData;
      let convertedBookingData = convertAppointmentFromApiModel(
        translatedData.actionData,
        payload.data.appointmentStepData,
        payload.data.advancedAppointmentStepData,
        window.userTimezone
      );
      window.bookingId = translatedData.actionData.id;
      convertedBookingData.invoiceData = translatedData.actionData.invoiceData;
      convertedBookingData.loadedCache = true;

      window.dispatch(loadCachedExistingBooking(convertedBookingData));
      window.dispatch(updateBookingOnlyCustomerProfileData(convertedBookingData.appointmentStepData.selectedCustomer));
      break;
    case "sendTokenCookie":
      if (!translatedData.actionData.tokenCookie)
        console.error("tokenCookie is missing");
      else {
        let parsedToken = decodeURIComponent(
          translatedData.actionData.tokenCookie
        );
        if (parsedToken != translatedData.actionData.tokenCookie) {
          //find out if the token we received was encoded
          parsedToken = decodeURIComponent(
            translatedData.actionData.tokenCookie
          ).replace("+", " ");
        }
        if (parsedToken.indexOf("undefined") < 0) {
          window.sessionStorage.setItem("token_authorization", parsedToken);
        }
      }
      break;

    case "tellBookingFormToMoveAppointment": //TODO KEEP WORKING HERE
      if (!translatedData.actionData.initialTimeDate)
        console.error("initialTimeDate is missing");

      let { initialTimeDate } = translatedData.actionData;
      startDateTime = convertDateTimeFromApi(initialTimeDate);
      formatedTime = convertTimeFromApi(initialTimeDate);
      internalTimeItem = timeList.find(x => x.stringValue == formatedTime);
      if (!internalTimeItem) {
        internalTimeItem = initialTimeDate;
      }
      window.dispatch(
        moveAppointmentTriggered(startDateTime, formatedTime, internalTimeItem)
      );
      break;
    case "setProviderId":
      if (!translatedData.actionData.providerId)
        console.error("providerId is missing");

      if (window.loadedCacheProviderData || isInternetExplorer()) {
        window.SERVICE_PROVIDER_ID = translatedData.actionData.providerId;
        window.dispatch(getStaffServicesAndMore());
      }
      if (!window.loadedCacheUserData) {
        window.dispatch(getProfileForCurrentUser());
      }
      break;
    case "setLocationId":
      if (!translatedData.actionData.locationId)
        console.error("locationId is missing");

      window.LOCATION_ID = translatedData.actionData.locationId;
      break;
    case "setAppointmentTime":
      if (!translatedData.actionData.selectedStartDateTime)
        console.warn("selectedStartDateTime missing");
      if (!translatedData.actionData.selectedResourceId)
        console.warn("selectedResourceId missing");
      if (!translatedData.actionData.selectedFirstDuration)
        console.warn("selectedFirstDuration missing");
      if (!translatedData.actionData.selectedServiceId)
        console.warn("selectedServiceId missing");

      let { selectedStartDateTime } = translatedData.actionData;

      startDateTime = convertDateTimeFromApi(selectedStartDateTime);
      formatedTime = convertTimeFromApi(selectedStartDateTime);
      internalTimeItem = timeList.find(x => x.stringValue == formatedTime);
      if (!internalTimeItem) {
        internalTimeItem = selectedStartDateTime;
      }
      locationId = get(translatedData, "actionData.selectedLocationId", void 0);
      window.LOCATION_ID = locationId;

      window.dispatch(
        updateAppointmentStepStartDateTime(
          startDateTime,
          internalTimeItem,
          translatedData.actionData.selectedResourceId,
          translatedData.actionData.selectedServiceId,
          locationId
        )
      );
      break;
    default:
      console.info("incorrect message sent", event.data);
  }
}
